import { WrappedData } from './types.js';

export class DataLoader {
  private data: WrappedData | null = null;

  async load(): Promise<WrappedData> {
    try {
      // Fetch from local API endpoint
      const response = await fetch('/api/data');
      if (!response.ok) {
        throw new Error(`Failed to load data: ${response.statusText}`);
      }
      const loadedData = await response.json() as WrappedData;
      this.data = loadedData;
      return loadedData;
    } catch (error) {
      console.error('Error loading data:', error);
      throw error;
    }
  }

  getData(): WrappedData {
    if (!this.data) {
      throw new Error('Data not loaded. Call load() first.');
    }
    return this.data;
  }

  getAuthors(): string[] {
    if (!this.data) {
      throw new Error('Data not loaded. Call load() first.');
    }
    return Object.keys(this.data.commitsByAuthor || {});
  }
}
